import React from "react";
import { useDownloadBanner } from "../../context/DownloadBannerContext";
import playStore from "../Images/PlayStore.png";
import appStore from "../Images/AppStore.png";
import { CloseIcon } from "../../assets/icons";

const DownloadBanner: React.FC = () => {
  const { os, isBannerVisible, dismissBanner } = useDownloadBanner();

  // Don't render if banner is not visible
  if (!isBannerVisible) return null;

  const appStoreLink = "https://apps.apple.com/app/id6504359243";
  const googlePlayLink =
    "https://play.google.com/store/apps/details?id=com.esemie";

  const storeLink = os === "ios" ? appStoreLink : googlePlayLink;
  const storeText = os === "ios" ? "  IOS" : "Andriod";
  const storeLogo = os === "ios" ? appStore : playStore;

  const handleDownloadClick = () => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "download_click",
      platform: os === "ios" ? "iOS" : "Android",
      action: "Download App",
    });
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 p-4">
      <div className="relative bg-white p-3 rounded-lg shadow-lg max-w-[350px] min-w-[250px]">
        <div className="flex flex-col gap-2 text-start">
          <h3 className="font-semibold">{`Get the Esemie ${storeText} app`}</h3>
          <p className="text-sm font-medium text-gray-500">
            Use Esemie on the go—download now and manage your business anytime,
            anywhere!
          </p>
          <div className="mt-3 flex gap-4">
            <a
              onClick={handleDownloadClick}
              href={storeLink}
              target="_blank"
              className="w-max rounded-md transition-transform duration-200 hover:scale-[1.03]"
            >
              <img src={storeLogo} alt="Close" className="h-[40px]" />
            </a>
            <button
              onClick={dismissBanner}
              className="h-[40px] px-[24px] font-semibold flex justify-center items-center text-black bg-slate-300 border border-slate-100 rounded-md transition-all duration-200 hover:border-slate-700"
            >
              Dismiss
            </button>
          </div>
        </div>
        <button
          className="absolute top-[14px] right-[14px] cursor-pointer"
          onClick={dismissBanner}
        >
          <CloseIcon />
        </button>
      </div>
    </div>
  );
};

export default DownloadBanner;
